/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BScroll from '@/components/Bscroll';
import BottomLine from '@/components/BottomLine';
import { GetDocList } from '@/api';
import userDefault from "@/resources/images/doctorDefault.png";
import CopyRight from 'CopyRight';
import DoctorItem from '@/components/DoctorItem';
import NoData from '@/components/NoData';
export default {
  data: function data() {
    return {
      docs: [],
      pageNo: 1,
      pageSize: 10,
      myScroll: null,
      noData: false,
      totalPage: 1,
      loadStatus: 1,
      //加载状态 0:正在加载中  1:上拉加载更多  2:无更多数据
      ifChainClinic: false,
      isHideEmptySign: false
    };
  },
  created: function created() {
    this.ifChainClinic = this.$route.query.ifChainClinic == 'true' ? true : false;
    console.log('ifChainClinic:   ');
    console.log(this.$route.query);
    console.log(this.$route.query.ifChainClinic);
    console.log(this.ifChainClinic);
    this.fetchDocList();
  },
  components: {
    CopyRight: CopyRight,
    DoctorItem: DoctorItem,
    NoData: NoData,
    BScroll: BScroll,
    BottomLine: BottomLine
  },
  methods: {
    descMethod: function descMethod(desc) {
      return desc ? desc.split('\n').join('<br/>') : '';
    },
    scrollEnd: function scrollEnd() {
      if (this.totalPage <= this.pageNo) {
        this.loadStatus = 2;
        return;
      }

      if (!this.noData) {
        // 获取下一页的数据处理
        this.pageNo += 1;
        this.fetchDocList();
      }
    },

    /**
     * 获取医生清单数据
     */
    fetchDocList: function fetchDocList() {
      var _this = this;

      var that = this;
      this.loadStatus = 0; // 调用20002接口

      GetDocList({
        pageNo: that.pageNo,
        pageSize: that.pageSize
      }).then(function (data) {
        // 接口返回数据
        var docs = data;
        _this.loadStatus = 1;

        if (docs.dataSource) {
          var _that$docs;

          (_that$docs = that.docs).push.apply(_that$docs, _toConsumableArray(docs.dataSource));

          that.totalPage = docs.totalPage;

          if (_this.totalPage <= _this.pageNo) {
            _this.loadStatus = 2;
          } // if (that.pageNo < this.totalPage) {
          //     that.pageNo++;
          // }

        }

        if (docs.dataSource && docs.dataSource.length == 0) {
          that.pageNo--;
        }

        docs.dataSource.forEach(function (v, i, array) {
          v.isShowMore = false;
        });
        _this.isHideEmptySign = _this.emptyFlag(that.docs);
      });
    },
    goDocterDetail: function goDocterDetail(doctorId, clinicId) {
      if (this.ifChainClinic) {
        this.$router.push({
          name: 'ChainDoctorDetail',
          query: {
            id: doctorId,
            childClinicId: clinicId
          }
        });
      } else {
        this.$router.push({
          name: 'DoctorDetail',
          query: {
            id: doctorId
          }
        });
      }
    },
    emptyFlag: function emptyFlag(data) {
      if (data.length == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    /** 返回一个合法可用的医生列表 */
    docList: function docList() {
      return this.docs || [];
    },
    loadText: function loadText() {
      var loadStatus = this.loadStatus;

      switch (loadStatus) {
        case 0:
          return '正在加载中';

        case 1:
          return '上拉加载更多';

        case 2:
          return '无更多数据';
      }
    }
  }
};